<app-upload-files *ngIf="allowUpload" [uploadFilesSettings]="uploadFilesSettings"
    (uploadedEvent)="uploadedEvent($event)">
</app-upload-files>

<app-loading-panel [isLoading]="isLoading" [size]="'small'"></app-loading-panel>
<ng-container *ngIf="documentInfos$ | async;let documentInfos">
    <kendo-grid *ngIf="documentInfos?.length > 0" [loading]="isLoading" [data]="documentInfos" [size]="'small'">

        <kendo-grid-column field="type" title="{{'claims-center.claimDocumentation.documentType' | translate}}"
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-document="dataItem">
                <app-document-info-description [documentInfo]="document"></app-document-info-description>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column *ngIf="showNameColumn" field="name" title="{{'claims-center.claimDocumentation.name' | translate}}"
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-document="dataItem">
                <span>{{document.name }}</span>
            </ng-template>
        </kendo-grid-column>


        <kendo-grid-column field="timestamp" title="{{'claims-center.claimDocumentation.addingDate' | translate}}"
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-document="dataItem">
                <span>{{document.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="createdBy" title="{{'claims-center.claimDocumentation.addedBy' | translate}}"
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-document="dataItem">
                <span>{{document.createdBy }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column *ngIf="showInfoColumn" field="exportInfo" title="{{'claims-center.claimDocumentation.exportInfo' | translate}}"
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-document="dataItem">
                <kendo-badge-container *ngIf="document.isAudanetExported"
                    title="{{document.audanetExportedBy}}({{document.audanetExportedTimestamp}})">
                    <img src="./assets/img/audatex_logo.jpg" [width]="48" alt="audatex" />

                    <kendo-badge size="small" themeColor="success" [align]="align" [position]="'inside'">
                        <kendo-icon [name]="'upload'"></kendo-icon>
                    </kendo-badge>

                </kendo-badge-container>
            </ng-template>
        </kendo-grid-column>


        <kendo-grid-column field="actions" title="" media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-document="dataItem">
                <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!document.isArchived">
                    <button kendoButton look="flat" icon="image" (click)="showContent(document)"> </button>
                    <button kendoButton look="flat" (click)="showContentInExternalWindow(document.id)"> <img
                            src="./assets/img/external_window.png" [width]="16" alt="external-window" /></button>
                    <button kendoButton look="flat" icon="delete" (click)="remove(document.id)"> </button>
                    <app-export-document-select [documentId]="document.id"></app-export-document-select>
                    <button kendoButton look="flat" icon="download" (click)="downloadSingleFile(document)"> </button>
                </div>

                 <div fxLayout="row" fxLayoutAlign="center center" *ngIf="document.isArchived">
                    <strong>{{'claims-center.claimDocumentation.documentIsAlreadyArchived' | translate}}</strong>
                </div>

            </ng-template>
        </kendo-grid-column>

        <!-- Mobile view for docs -->
        <kendo-grid-column title="" media="(max-width: 1007px)" class="mobile-grid-column">
            <ng-template kendoGridCellTemplate let-document="dataItem">
                <div fxLayout="column" class="form-block mobile-grid-column-item">
                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">

                        <div fxFlex="98" fxLayout="column">
                            <app-document-info-description [documentInfo]="document"></app-document-info-description>
                            <span>{{document.name }}</span>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.addingDate' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <span>{{document.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
                            <span>{{document.createdBy }}</span>
                        </div>
                    </div>

                    <div *ngIf="showInfoColumn" fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.exportInfo' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <kendo-badge-container *ngIf="document.isAudanetExported"
                                title="{{document.audanetExportedBy}}({{document.audanetExportedTimestamp}})">
                                <img src="./assets/img/audatex_logo.jpg" [width]="48" alt="audatex" />

                                <kendo-badge size="small" themeColor="success" [align]="align" [position]="'inside'">
                                    <kendo-icon [name]="'upload'"></kendo-icon>
                                </kendo-badge>

                            </kendo-badge-container>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">

                        <div fxFlex="98" fxLayout="row">
                            <button kendoButton look="flat" icon="image" (click)="showContent(document)"> </button>
                            <button kendoButton look="flat" (click)="showContentInExternalWindow(document.id)"> <img
                                    src="./assets/img/external_window.png" [width]="16"
                                    alt="external-window" /></button>
                            <button kendoButton look="flat" icon="delete" (click)="remove(document.id)"> </button>
                            <app-export-document-select [documentId]="document.id"></app-export-document-select>
                            <button kendoButton look="flat" icon="download" (click)="downloadSingleFile(document)">
                            </button>
                        </div>

                         <div fxFlex="98" fxLayout="row-wrap" *ngIf="document.isArchived">
                            <strong>{{'claims-center.claimDocumentation.documentIsAlreadyArchived' | translate}}</strong>
                        </div>
                    </div>

                </div>
            </ng-template>
        </kendo-grid-column>

    </kendo-grid>
</ng-container>
<div kendoDialogContainer #showDocumentsMultipleDialog></div>